import React from 'react';
import { withTheme } from 'styled-components';
import {Button} from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import messages from './messages';
import Modal from 'components/Modal';
import { PublicationAlertModalContent, PublicationAlertModalActions } from './styles';

const PublicationAlertModal = ({visible, onDismiss, onPublish}) => (
  <Modal visible={visible} onDismiss={onDismiss}>
    <PublicationAlertModalContent>
      {intl.formatMessage(messages.publicationAlertMessage)}
    </PublicationAlertModalContent>
    <PublicationAlertModalActions>
      <Button primary onClick={onPublish}>{intl.formatMessage(messages.ok)}</Button>
    </PublicationAlertModalActions>
  </Modal >
);

export default withTheme(PublicationAlertModal);
